/**
 * TMR Match Value directive
 *
 * Adds a validator callback to a model that checks if the value entered in
 * the field matches another field, identified by name. Useful for "repeat
 * password" fields.
 *
 * @example
 * <input name="PassowrdA" type="password">
 * <input name="PassowrdB" tmr-match-Value="PassowrdA" type="password">
 *
 * @namespace
 * @alias tmrMatchValue
 * @type {ngDirective}
 */
let tmrMatchValueDirective = /*@ngInject*/ () => ({
  link: (scope, elm, attrs, ctrl) => {
    let ngModel = ctrl[0]
    let otherValueModel = ctrl[1][attrs.tmrMatchValue]

    scope.$watch(
      () => otherValueModel.$viewValue,
      () => ngModel.$$parseAndValidate()
    )

    ngModel.$validators.tmrMatchValue = modelValue =>
      (!modelValue && !otherValueModel.$modelValue) ||
      modelValue === otherValueModel.$modelValue

    otherValueModel.$parsers.push(value => {
      ngModel.$setValidity(
        'tmrMatchValue',
        (!value && !ngModel.$viewValue) || value === ngModel.$viewValue
      )
      return value
    })
  },
  require: ['^ngModel', '^form'],
  restrict: 'A',
})

export const directive = ['tmrMatchValue', tmrMatchValueDirective]
